import { path } from "../paths";

const ROOTS_PROCUREMENT = "/procurement";

export const PATH_PROCUREMENT = {
  root: ROOTS_PROCUREMENT,
  general: {
    purchaseRequisition: {
      root: path(ROOTS_PROCUREMENT, "/purchase-requisition"),
      general: {
        purchaseRequisitionList: path(
          ROOTS_PROCUREMENT,
          `/purchase-requisition/list`,
        ),
        purchaseRequisitionDraft: path(
          ROOTS_PROCUREMENT,
          "/purchase-requisition/drafts",
        ),
        purchaseRequisitionCreate: path(
          ROOTS_PROCUREMENT,
          "/purchase-requisition/create",
        ),
      },
    },
    grn: {
      root: path(ROOTS_PROCUREMENT, "/grn"),
      general: {
        grnList: path(ROOTS_PROCUREMENT, "/grn/list"),
      },
    },
    purchaseOrder: {
      root: path(ROOTS_PROCUREMENT, "/purchase-order"),
      general: {
        purchaseOrderCreate: path(ROOTS_PROCUREMENT, "/purchase-order/create"),
        purchaseOrderList: path(ROOTS_PROCUREMENT, "/purchase-order/list"),
        purchaseOrderDraft: path(ROOTS_PROCUREMENT, "/purchase-order/drafts"),
      },
    },
  },
};
